export const getHoveredBarChartSectionId = (element: Element | null): string => {
    if (element?.closest('[id="bar-chart-sidebar-footer"]')) {
        return "bar-chart-sidebar-footer"
    } else if (element?.closest('[id="bar-chart-sidebar-stacked-bar-chart"]')) {
        return "bar-chart-sidebar-stacked-bar-chart";
    }
    return 'bar-chart-sidebar-header';
};